import { RESET_STATE } from 'store/global/actions';

import { INVESTOR_PRODUCT_PLAN_IDENTIFIERS_ACTION_TYPE } from '../actions';

const initialState = {};

const investorProductPlanIdentifiersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case INVESTOR_PRODUCT_PLAN_IDENTIFIERS_ACTION_TYPE.GET_INVESTOR_PRODUCT_PLAN_IDENTIFIERS:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default investorProductPlanIdentifiersReducer;
